import { Card, FormField, Input } from '@playerbase/ui';

import {
  type BuilderMetadata,
  type UseFormBuilderState,
} from '../../../games/use-form-builder-state.js';

interface SubmitResponseCardProps {
  metadata: BuilderMetadata;
  builder: UseFormBuilderState;
}

// What the player sees as an ephemeral message after submitting. Required
// before Enable (PR 4 enforces); the column is nullable in the DB so a
// mid-build draft can be empty.
export function SubmitResponseCard({
  metadata,
  builder,
}: SubmitResponseCardProps): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Card.Title>Submit response</Card.Title>
        <Card.Description>
          The thank-you message Discord sends back when a player submits.
        </Card.Description>
      </Card.Header>
      <Card.Content className="flex flex-col gap-4">
        <FormField>
          <FormField.Label
            className="font-mono text-[10px] font-semibold uppercase tracking-wider text-text-muted"
            data-required
          >
            Title
          </FormField.Label>
          <FormField.Control>
            <Input
              value={metadata.submitResponseTitle}
              onChange={(e) =>
                builder.updateMetadata({ submitResponseTitle: e.target.value })
              }
              maxLength={80}
              placeholder="Thanks for the feedback!"
            />
          </FormField.Control>
        </FormField>

        <FormField>
          <FormField.Label className="font-mono text-[10px] font-semibold uppercase tracking-wider text-text-muted">
            Description
          </FormField.Label>
          <FormField.Control>
            <Input
              value={metadata.submitResponseDescription}
              onChange={(e) =>
                builder.updateMetadata({ submitResponseDescription: e.target.value })
              }
              maxLength={200}
              placeholder="Optional. We read every response."
            />
          </FormField.Control>
        </FormField>
      </Card.Content>
    </Card>
  );
}
